import handleError from 'App/modules/api/handle-error.js';
import handleRequest from 'App/modules/api/handle-request.js';
import handleSuccess from 'App/modules/api/handle-success.js';
import Vue from 'vue';

function loadAllProjectsStreaming({ dispatch, commit, state, getters }, payload) {
	// console.time('loadAllProjectsStreaming\n');
	// console.log('<(ACTION) loadAllProjectsStreaming', payload, ')>');
	if (state.status['all_' + payload.type] !== 2 || payload.force) {
		if (!payload.force) {
			Quasar.plugins.Loading.show({ message: ``, spinner: 'QSpinnerTail' });
		}
		if (!payload.force) {
			commit('CLEAR_FILTERED');
			commit('SET_STATUS', { type: 'all_' + payload.type, status: 1 });
		}
		commit('SET_ALL_' + payload.type.toUpperCase(), []);
		dispatch('loadPage', { page: 1, maxProjects: 12 });
		const apiURL = '/api/projects?page=' + payload.type + '&init=' + payload.init;
		const requestNumber = handleRequest(
			{
				url: apiURL,
				data: { page: payload.type, init: payload.init },
				method: 'GET'
			},
			'OBOE '
		);
		window.getAllProjectsStream = oboe({
			// getAllProjectsStream.abort() to stop receiving projects
			// url: 'https://staging.simpleshow-cockpit.com/api/projects?page=' + payload.type,
			url: apiURL,
			// url: '/api/projects',
			headers: {
				'X-CSRF-TOKEN': window.axios.defaults.headers.common['X-CSRF-TOKEN'],
				'X-XSRF-TOKEN': getters.getCookie('XSRF-TOKEN')
			}
		})
			.on('start', function (status, headers) {
				// commit('SET_STATUS', { type: 'all_' + payload.type, status: 2 });
			})
			.node('!.meta', function (meta) {
				// console.error(meta.total);
				// console.error(meta.latest);
				commit('SET_META_' + payload.type.toUpperCase(), meta);
				var totalNumberOfProjects = new Intl.NumberFormat().format(state.meta[payload.type].total);
				var numberOfFilteredProjects = new Intl.NumberFormat().format(getters.getNumberOfFiltered);
				if (!payload.force) {
					Quasar.plugins.Loading.show({ message: `Starting up...`, spinner: 'QSpinnerTail' });
				}
				$('.q-loading>div').html(
					'Loading project ' +
						numberOfFilteredProjects +
						' of ' +
						totalNumberOfProjects +
						' projects total.<br>Hang on...'
				);
				// commit('PUSH_TO_ALL_' + payload.type.toUpperCase(), project);
				// commit('SET_STATUS', { type: 'all_' + payload.type, status: 2 });
			})
			.node('!.data.*', function (project) {
				// console.log(project);
				// console.count('PUSH_BEFORE');
				var totalNumberOfProjects = new Intl.NumberFormat().format(state.meta[payload.type].total);
				var numberOfFilteredProjects = new Intl.NumberFormat().format(getters.getNumberOfFiltered);
				$('.q-loading>div').html(
					'Loading project ' +
						numberOfFilteredProjects +
						' of ' +
						totalNumberOfProjects +
						' projects total.<br>Hang on...'
				);
				// commit('PUSH_TO_ALL_' + payload.type.toUpperCase(), project);
				// dispatch('loadPage', { page: 1, maxProjects: 12 });
			})
			.done(function (response) {
				// console.log('[loadAllProjectsStreaming] response: ', response);
				Quasar.plugins.Loading.hide();
				if (response.data) {
					handleSuccess(
						{
							config: {
								number: requestNumber,
								url: apiURL,
								method: 'GET'
							},
							data: response
						},
						'OBOE '
					);
					// console.log('there are', response.data.length, 'projects');
					// console.log('response:', response);
					commit('SET_FILTERED', response.data);
					commit('SET_STATUS', { type: 'filtered', status: 2 });
					commit('SET_LOADED_' + payload.type.toUpperCase(), true);
					commit('SET_ALL_' + payload.type.toUpperCase(), response.data);
					dispatch('loadPage', { page: 1, maxProjects: 12 });
					if (payload.init) {
						// dispatch('loadPage', { page: 1, maxProjects: 12 });
						setTimeout(() => {
							payload.init = false;
							payload.force = true;
							dispatch('loadAllProjectsStreaming', payload);
						}, 1000);
					} else {
						commit('SET_STATUS', { type: 'all_' + payload.type, status: 2 });
					}
				} else {
					console.log('FAIL!');
					console.log('response:', response);
				}
				// console.timeEnd('loadAllProjectsStreaming\n');
				return response;
			})
			.fail(function (e) {
				handleError(
					{
						config: {
							number: requestNumber,
							url: apiURL,
							method: 'GET'
						},
						response: e
					},
					'OBOE '
				);
				Quasar.plugins.Loading.hide();
				console.log('ERROR:', '(' + e.statusCode + ')', e.jsonBody.message);
				commit('SET_ALL_' + payload.type.toUpperCase(), []);
				commit('SET_STATUS', { type: 'all_' + payload.type, status: 3 });
				commit('SET_FILTERED', []);
				commit('SET_STATUS', { type: 'filtered', status: 3 });
				if (e.statusCode === 401 || e.statusCode === 419) {
					window.location.href = '/login';
				}
				// dispatch('loadPage', { page: 1, maxProjects: 12 });
				// console.timeEnd('loadAllProjectsStreaming\n');
				return e;
			});
	} else {
		commit('SET_STATUS', { type: 'all_' + payload.type, status: 1 });
		if (payload === 'sandboxed') {
			commit('SET_FILTERED', state.all_sandboxed);
		} else if (payload === 'approved') {
			commit('SET_FILTERED', state.all_approved);
		}
		commit('SET_STATUS', { type: 'all_' + payload.type, status: 2 });
		dispatch('loadPage', { page: 1, maxProjects: 12 });
		if (process.env.NODE_ENV !== 'production')
			Vue.ToastSwal.fire('No need!', `Projects are already loaded.`, 'info');
	}
}

export default loadAllProjectsStreaming;
